<template>
  <div class="host page">
    <DataTable
      title="Международный классификатор болезней"
      :permissions="['read']"
      :service="service"
      :fields="tableFileds"
      :pageSize="20" 
    />
  </div>
</template>

<script>
import DataTable from '@app/components/uikit/DataTable';
import { dictionaryMkb10Api } from '@app/services';
 
export default {
  components: {
    DataTable
  },
  data: () => ({
    service: dictionaryMkb10Api,
    tableFileds: [
      {
        name: 'MKB_CODE',
        label: 'Код МКБ-10'
      },
      {
        name: 'MKB_NAME',
        label: 'Наименование'
      },
    ],
  })
};
</script>
